<orders-table *ngrxLet="tableModel$ as vm" [orders]="vm.orders" [orderColumns]="vm.columns" />
